module.exports = __webpack_public_path__ + "img/exc_1.07d3d4e1.webp";